'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icon = require('./icon.css');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
  var type = _ref.type,
      width = _ref.width,
      height = _ref.height;

  var size = {
    width: width || 'auto',
    height: height || 'auto'
  };

  return _react2.default.createElement(
    'svg',
    { className: _icon2.default.icon, style: size },
    _react2.default.createElement('use', { xlinkHref: '/images/icons.svg#icon-' + type })
  );
};

Icon.propTypes = {
  type: _react.PropTypes.string.isRequired,
  width: _react.PropTypes.number,
  height: _react.PropTypes.number
};

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.js
// module id = 54
// module chunks = 1